import { Component, OnInit } from '@angular/core';
import {BaseDatabaseService} from '../shared/services/databaseServices/BaseDatabaseService';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';
import {LoginService} from './services/login.service';
import {VersionService} from '../shared/services/versionService/version.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent extends BaseDatabaseService implements OnInit {

  public badLogin = false;
  public loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    }
  );

  constructor(private router: Router,
              private formBuilder: FormBuilder,
              private loginService: LoginService,
              private versionService: VersionService) {
    super();
  }

  ngOnInit() {
  }

  login() {
    this.loginService.loginWithEmail(this.loginForm.value.email, this.loginForm.value.password)
      .then( (data) => {
          this.loginService.saveCurrentUser();
          this.router.navigate(['/admin']);
      } )
      .catch( (err) => {
        this.badLogin = true;
      });
  }


}
